<template>
    <div>
        <div class="row mr-1">
            <div
                class="col-12 mb-3"
                align="right"
            >

                <a
                    :href="$store.state.api + 'download/import-model-user'"
                    target="_blank"
                    class="btn btn-add"
                >Modelo
                 de
                 Importação
                </a>

                <button
                    class="btn btn-importar"
                    @click="openInput"
                >
                    Importar Aprovadores
                </button>
                <input
                    name="fileImport"
                    id="fileImport"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style="display: none"
                    value="null"
                    @change="importFile"
                />

            </div>
            <div
                class="col-md-12 mt-4"
                v-if="showMessageImport"
            >
                <div
                    class="alert alert-success"
                    role="alert"
                >
                    <strong>Planilha importada com sucesso!</strong>
                    <br/>
                    Definimos uma senha padrão para todos os usuários, a senha definida é:
                    <strong>Alterar123</strong>, sugerimos que os usuários alterem-a logo
                    no primeiro acesso.
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <base-crud
                :ref="'usersCrud'"
                crudName="Usuários"
                newText="Novo Usuário"
                :table="table"
                :columns="columns"
                :options="options"
                :endPoint="endPoint"
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="true"
                :dataForm="dataForm"
            ></base-crud>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
    data: function () {
        return {
            showMessageImport: false,
            table: "usersTable",
            pages: [],
            url: "",
            columns: [
                "id",
                "name",
                "access_nivel",
                "matriculation",
                "email",
                "actions",
            ],
            tableData: ["id", "name", "access_nivel", "matriculation", "email"],
            options: {
                sortable: ["id", "name", "access_nivel", "matriculation", "email"],
                filterByColumn: true,
                debounce: 1000,
                filterable: ["id", "name", "access_nivel", "matriculation", "email"],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    name: "Nome",
                    access_nivel: "Nível de Acesso",
                    matriculation: "Matrícula",
                    email: "E-mail",
                    actions: "Ações",
                },

                texts: {
                    filterBy: "Filtrar",
                    defaultOption: "Selecione",
                },
                listColumns: {
                    access_nivel: [
                        {
                            id: 3,
                            text: "Administrador",
                        },
                        {
                            id: 2,
                            text: "Gestor",
                        },
                        {
                            id: 1,
                            text: "Usuário Padrão",
                        },
                    ],
                },
                templates: {
                    access_nivel: function (h, row, index) {
                        return row.access_nivel == 3
                            ? "Administrador"
                            : row.access_nivel == 1
                                ? "Usuário Padrão"
                                : row.access_nivel == 4
                                    ? "Administrador de Filial"
                                    : "Gestor";
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "users/",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            let fileImport = document.getElementById("fileImport");

            fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

            return fd;
        },
        importFile() {
            const self = this;
            let api = self.$store.state.api + "import-users";

            let fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.showMessageImport = true;
                    self.$refs.usersCrud.$refs.table.refresh();
                })
                .catch((error) => {
                    self.$message(
                        "Ops",
                        "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
                        "error"
                    );
                });
        },
        query: function (query) {
            let columns = {
                id: "id",
                name: "name",
                access_nivel: "access_nivel",
                matriculation: "matriculation",
                email: "email",
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        openInput() {
            document.getElementById("fileImport").click();
        },
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Crud.vue